import { render, staticRenderFns } from "./ArticleCarousel.vue?vue&type=template&id=61ade246&"
import script from "./ArticleCarousel.vue?vue&type=script&lang=js&"
export * from "./ArticleCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ArticleCarousel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports